// src/pages/OngoingPage.tsx
import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction"; // MUI icon as placeholder
interface OngoingPageProps {
  title: string;
}
const OngoingPage: React.FC<OngoingPageProps> = ({ title }) => {
  return (
    <Box
      sx={{
        height: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 500,
        }}
      >
        <ConstructionIcon color="warning" sx={{ fontSize: 64, mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom>
          Under Construction
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 2 }}>
          The <strong>{title}</strong> page is currently being developed.
          <br />
          We’re working hard to bring you new features and updates.<br />
          Please check back soon or contact the site administrator if you need more information.
        </Typography>
        <Typography variant="caption" color="text.disabled">
          Thank you for your patience and understanding.
        </Typography>
      </Paper>
    </Box>
  );
};

export default OngoingPage;